import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { Download } from "lucide-react";

const AlertsGraph = ({ data }) => {
  console.log("data", data);

  // ✅ Use the API array directly (each object already has date + counts)
  const chartData =
    data &&
    data?.map((item) => ({
      date: item.date,
      attendance: item.attendance_logs,
      checkin: item.checkin_checkout_logs,
      crowd: item.crowd_detection_logs,
      door: item.door_logs,
      fire: item.fire_detection_logs,
      notification: item.notification_logs,
      numberPlate: item.number_plate_logs,
      queue: item.queue_waiting_logs,
      seat: item.seat_monitoring_logs,
    }));

  // ✅ Define colors for each log type
  const colors = {
    attendance: "#6c63ff",
    checkin: "#ff6b6b",
    crowd: "#4dabf7",
    door: "#f59f00",
    fire: "#37b24d",
    notification: "#e64980",
    numberPlate: "#15aabf",
    queue: "#fab005",
    seat: "#82ca9d",
  };

  return (
    <div className="alerts-card">
      <div className="alerts-header">
        <h3>Logs Counts</h3>
        <button className="download-btn">
          <Download size={16} /> Download CSV
        </button>
      </div>

      <ResponsiveContainer width="100%" height={380}>
        <BarChart
          data={chartData}
          margin={{ top: 30, right: 30, left: 10, bottom: 40 }}
        >
          {/* ✅ Dates on X-axis */}
          <XAxis dataKey="date" angle={-20} textAnchor="end" height={60} />

          {/* ✅ Y-axis auto */}
          <YAxis />

          {/* ✅ Tooltip */}
          <Tooltip formatter={(val) => val.toLocaleString()} />

          {/* ✅ Legend */}
          <Legend />

          {/* ✅ Stacked Bars for each log type */}
          {Object.keys(colors).map((key) => (
            <Bar
              key={key}
              dataKey={key}
              stackId="logs"
              fill={colors[key]}
              radius={[4, 4, 0, 0]}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AlertsGraph;
